// removed by extract-text-webpack-plugin
module.exports = {"outer":"_30zJ","active":"_2aRA","time":"_17U3","message":"_3w30"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Messages/ThreadListItem/ThreadListItem.scss
// module id = EPqN
// module chunks = 0